export enum ContentTrackTypes {
	PLAY = 'play',
	SPIN_UP = 'spinup'
}
